import { createRFESandbox } from "@amzn/region-flex-interface-module-website-common";
import "@amzn/region-flex-interface-module-website-common/style.css";
import * as BaseUrl from "./modules/baseUrl";
import * as MigrationStep from "./modules/migrationStep";

// This allows for local and integration testing of the module,
// in a mock environment that mimic the environment in the
// main website.
// You can pass in as many modules as you want here, although
// we reccommend seperating out modules into their own packages
createRFESandbox([BaseUrl, MigrationStep]);
